export default __webpack_public_path__ + "static/media/testimonail_logo.9a6c087e.svg";